import { apiClient } from '../api.client';
import type { User } from '../../types/auth';

export const authReal = {
  login: async (
    email: string,
    password: string
  ): Promise<{ user: User; token: string }> => {
    return apiClient.post<{ user: User; token: string }>(
      '/auth/login',
      { email, password },
      false
    );
  },

  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout', {});
  },

  sendPasswordResetEmail: async (email: string): Promise<void> => {
    await apiClient.post('/auth/reset-password', { email }, false);
  },

  // Il backend legge l'utente dal token Sanctum — non serve passare l'email nel body
  resendConfirmationEmail: async (): Promise<void> => {
    await apiClient.post('/auth/resend-confirmation', {});
  },

  register: async (
    name: string,
    dateOfBirth: string,
    email: string,
    password: string
  ): Promise<{ user: User; token: string }> => {
    return apiClient.post<{ user: User; token: string }>(
      '/auth/register',
      {
        name,
        date_of_birth: dateOfBirth,
        email,
        password,
        password_confirmation: password,
      },
      false
    );
  },

  registerFree: async (
    email: string
  ): Promise<{ user: User; token: string }> => {
    return apiClient.post<{ user: User; token: string }>(
      '/auth/register/free',
      { email },
      false
    );
  },

  sendFreeLoginLink: async (email: string): Promise<void> => {
    await apiClient.post('/auth/login/free', { email }, false);
  },

  resetPasswordConfirm: async (
    email: string,
    token: string,
    password: string
  ): Promise<void> => {
    await apiClient.post(
      '/auth/reset-password/confirm',
      { email, token, password, password_confirmation: password },
      false
    );
  },
};
